import { useRef as h, useState as L, useCallback as a, useEffect as l } from "react";
import { useForceLogoutUser as b } from "./useForceLogoutUser.js";
import { useSelector as C } from "react-redux";
const O = (y, D = 30, n = 30) => {
  const { user: d } = C((e) => e.app.datastate), c = Object.keys(d).length > 0, s = h(Date.now()), [f, o] = L(!1), [E, i] = L(n), w = b(), r = h(null), t = h(null), I = D * 60 * 1e3, T = n * 1e3, p = a(() => {
    const e = Date.now();
    s.current = e;
  }, []), m = a(() => {
    o(!1), r.current && clearTimeout(r.current), t.current && clearInterval(t.current), w(y, 0);
  }, [w, y]), g = a(() => {
    o(!1), i(n), s.current = Date.now(), r.current && (clearTimeout(r.current), r.current = null), t.current && (clearInterval(t.current), t.current = null);
  }, [n]), k = a(() => {
    o(!0), i(n), t.current = setInterval(() => {
      i((e) => e <= 1 ? (t.current && clearInterval(t.current), 0) : e - 1);
    }, 1e3), r.current = setTimeout(() => {
      m();
    }, T);
  }, [n, T, m]);
  return l(() => {
    if (!c) return;
    const e = setInterval(() => {
      if (f)
        return;
      Date.now() - s.current >= I && k();
    }, 1e4);
    return () => {
      clearInterval(e);
    };
  }, [I, f, k, c]), l(() => {
    if (!c) return;
    const e = [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "input"
    ];
    let u = null;
    const A = () => {
      u || (u = setTimeout(() => {
        p(), u = null;
      }, 3e3));
    };
    return e.forEach((v) => {
      window.addEventListener(v, A, !0);
    }), () => {
      e.forEach((v) => {
        window.removeEventListener(v, A, !0);
      }), u && clearTimeout(u);
    };
  }, [p, c]), l(() => {
    c || (o(!1), i(n), r.current && clearTimeout(r.current), t.current && clearInterval(t.current));
  }, [c, n]), l(() => {
    if (Object.keys(d).length !== 0)
      return () => {
        r.current && clearTimeout(r.current), t.current && clearInterval(t.current);
      };
  }, []), {
    showWarning: f,
    countdown: E,
    handleLogout: m,
    handleCancelLogout: g
  };
};
export {
  O as default
};
